/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Setting } from "../model"
/**
 * SettingResourceApi - axios parameter creator
 */
export const SettingResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get advisor\'s settings by its id
     * @param {string} advisorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSetting: async (
      advisorId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'advisorId' is not null or undefined
      assertParamExists("getSetting", "advisorId", advisorId)
      const localVarPath = `/settings/{advisorId}`.replace(
        "{advisorId}",
        encodeURIComponent(String(advisorId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update advisor\'s settings
     * @param {string} advisorId
     * @param {Setting} setting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSetting: async (
      advisorId: string,
      setting: Setting,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'advisorId' is not null or undefined
      assertParamExists("saveSetting", "advisorId", advisorId)
      // verify required parameter 'setting' is not null or undefined
      assertParamExists("saveSetting", "setting", setting)
      const localVarPath = `/settings/{advisorId}`.replace(
        "{advisorId}",
        encodeURIComponent(String(advisorId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        setting,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * SettingResourceApi - functional programming interface
 */
export const SettingResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SettingResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get advisor\'s settings by its id
     * @param {string} advisorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSetting(
      advisorId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Setting>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSetting(advisorId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SettingResourceApi.getSetting"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update advisor\'s settings
     * @param {string} advisorId
     * @param {Setting} setting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveSetting(
      advisorId: string,
      setting: Setting,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Setting>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveSetting(
        advisorId,
        setting,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SettingResourceApi.saveSetting"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * SettingResourceApi - factory interface
 */
export const SettingResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SettingResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get advisor\'s settings by its id
     * @param {SettingResourceApiGetSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSetting(
      requestParameters: SettingResourceApiGetSettingRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Setting> {
      return localVarFp
        .getSetting(requestParameters.advisorId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update advisor\'s settings
     * @param {SettingResourceApiSaveSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSetting(
      requestParameters: SettingResourceApiSaveSettingRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Setting> {
      return localVarFp
        .saveSetting(requestParameters.advisorId, requestParameters.setting, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getSetting operation in SettingResourceApi.
 */
export interface SettingResourceApiGetSettingRequest {
  readonly advisorId: string
}

/**
 * Request parameters for saveSetting operation in SettingResourceApi.
 */
export interface SettingResourceApiSaveSettingRequest {
  readonly advisorId: string

  readonly setting: Setting
}

/**
 * SettingResourceApi - object-oriented interface
 */
export class SettingResourceApi extends BaseAPI {
  /**
   *
   * @summary Get advisor\'s settings by its id
   * @param {SettingResourceApiGetSettingRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getSetting(
    requestParameters: SettingResourceApiGetSettingRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SettingResourceApiFp(this.configuration)
      .getSetting(requestParameters.advisorId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update advisor\'s settings
   * @param {SettingResourceApiSaveSettingRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saveSetting(
    requestParameters: SettingResourceApiSaveSettingRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SettingResourceApiFp(this.configuration)
      .saveSetting(requestParameters.advisorId, requestParameters.setting, options)
      .then(request => request(this.axios, this.basePath))
  }
}
